module.exports = {
  dish1: {
    name: "Burger 1",
    description: "Insert Burger 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Burger 2",
    description: "Insert Burger 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Burger 3",
    description: "Insert Burger 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Burger 4",
    description: "Insert Burger 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Burger 5",
    description: "Insert Burger 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Burger 6",
    description: "Insert Burger 6 description",
    price: 3000,
    status: "unavailable",
    vegetarian: true
  },
  dish7: {
    name: "Burger 7",
    description: "Insert Burger 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Burger 8",
    price: 4400,
    description: "Insert Burger 8 description",
    status: "available"
  },
  dish9: {
    name: "Burger 9",
    price: 3300,
    description: "Insert Burger 9 description",
    status: "available"
  },
  dish10: {
    name: "Burger 10",
    price: 3900,
    description: "Insert Burger 10 description",
    status: "available"
  },
  dish11: {
    name: "Burger 11",
    price: 11000,
    description: "Insert Burger 11 description",
    status: "available"
  },
  dish12: {
    name: "Burger 12",
    price: 12000,
    description: "Insert Burger 12 description",
    status: "available",
    vegetarian: true
  },
  dish13: {
    name: "Burger 13",
    price: 13000,
    description: "Insert Burger 13 description",
    status: "available"
  },
  dish14: {
    name: "Burger 14",
    price: 14000,
    description: "Insert Burger 14 description",
    status: "available"
  },
  dish15: {
    name: "Burger 15",
    price: 15000,
    description: "Insert Burger 15 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/2Kitchens.js